/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect, Suspense, useRef } from 'react';

import {
  Fade,
  IconButton,
  Tooltip
} from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import DatePicker from "react-multi-date-picker";
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import CmvAndCountSetupDialog from 'components/Dialogs/CmvAndCountSetup';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import FilterOpened from 'images/icons/filters/filter.svg';
import FilterClosed from 'images/icons/filters/filterIconLightBlueNoBgRounded.svg';
import CmvAndCountSetupIcon from 'images/icons/objects/boxesAndPackages/packageGrayConfigYellowLightBlueBgRounded.svg';
import CalendarFilterIcon from 'images/icons/objects/calendars/calendarGrayOutline.svg';
import DiscardPercentageAndValue from 'pages/inventory/diary-count/dialogs/DiscardPercentageAndValue'
import StorageLocationForm from 'pages/inventory/storage-Locations/StorageLocationForm';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';
import {
  handleMultipleFilters
} from 'utils/handleFilterActions';

import CmvTheoreticalInfos from './CmvTheoreticalInfos';
import PerformedCmvInfos from './PerformedCmvInfos';
import SalesInfos from './SalesInfos';
import SimpleLineGraphic from './SimpleLineGraphic';

const DifferenceInCount = React.lazy(() =>
  import('components/Dialogs/DifferenceInCount')
);

const PerformedCmvDialogInfos = React.lazy(() =>
  import('components/Dialogs/PerformedCmvInfos')
);

const TheoryStockDialog = React.lazy(() =>
  import('components/Dialogs/ExtractsDialog')
);

function CmvDashboard({ userInfo }) {
  const actualDate = moment();
  const actualDateLessOne = moment(actualDate)?.subtract(1, 'day')?.format('YYYY-MM-DD');
  const actualDateLessSeven = moment(actualDate)?.subtract(7, 'day')?.format('YYYY-MM-DD');
  const actualDateLessThirty = moment(actualDate)?.subtract(30, 'day')?.format('YYYY-MM-DD');
  const { id: paramsID } = useParams();
  const companyActive = userInfo.companiesActive.name;
  const [getId, setId] = useState(paramsID);
  const [filters] = useState([]);
  const [filtersChanged, setFiltersChanged] = useState(filters);
  const [loading, setLoading] = useState(false);
  const [salesInfoType, setSalesInfoType] = useState(true);
  const [salesInfos, setSalesInfos] = useState({
    loading: true,
    content: ''
  });
  const [cmvTheoreticalInfos, setCmvTheoreticalInfos] = useState({
    loading: true,
    content: ''
  });
  const [cmvPerformedInfos, setCmvPerformedInfos] = useState({
    loading: true,
    content: ''
  });
  const [cmvChartInfos, setCmvChartInfos] = useState({
    content: [],
    contentFormatted: [],
    labels: [],
    loading: false,
  });
  const environments = Environment(process.env.REACT_APP_ENV);
  const [updateStorageLocations, setUpdateStorageLocations] = useState(false);
  const [loadedStartDateDays, setLoadedStartDateDays] = useState(false);
  const [loadedEndDateDays, setLoadedEndDateDays] = useState(false);
  const [startDateDisabledDays, setStartDateDisabledDays] = useState('');
  const [openFilter, setOpenFilter] = useState(true)
  const [endDateDisabledDays, setEndDateDisabledDays] = useState('');
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterOldStartDate, setFilterOldStartDate] = useState('');
  const [filterStartDifferenceDate, setFilterStartDifferenceDate] = useState(null)
  const [filterEndDifferenceDate, setFilterEndDiferrenceDate] = useState(null)
  const [filterEndDate, setFilterEndDate] = useState('');
  const [dateChangeStart, setDateChangeStart] = useState()
  const [dateChangeEnd, setDateChangeEnd] = useState()
  const [filterOldEndDate, setFilterOldEndDate] = useState('');
  const [enabledCurrentStartDates, setEnabledCurrentStartDates] = useState([]);
  const [enabledCurrentEndDates, setEnabledCurrentEndDates] = useState([]);
  const [enabledNextStartDates, setEnabledNextStartDates] = useState([]);
  const [productModal, setProductModal] = useState({})
  const [infoDiscard, setInfoDiscard] = useState([])
  const [checkConsume, setCheckConsume] = useState(false);
  const [totalProductsCount, setTotalProductsCount] = useState({counts: []})
  const startDatePickerRef = useRef();
  const isStartDateSelectedRef = useRef(false);
  const isEndDateSelectedRef = useRef();
  const endDatePickerRef = useRef();

  const openStartCalendar = () => {
    if (startDatePickerRef.current) {
      startDatePickerRef.current.openCalendar();
    }
  };

  const openEndCalendar = () => {
    if (endDatePickerRef.current) {
      endDatePickerRef.current.openCalendar();
    }
  };

  const [modalSettings, setModalSettings] = useState([
    { id: 1, name: 'cmvAndCountSetupDialog', open: false, fullScreen: false },
    { id: 2, name: 'storageLocationDialog', open: false, fullScreen: false },
    { id: 3, name: 'differenceInCount', currentRestaurant: '', open: false, fullScreen: null, maxWidth: null },
    { id: 4, name: 'performedCmvInfos', open: false, fullScreen: null, maxWidth: null },
    { id: 5, name: 'discardPercentageAndValue', open: false, fullScreen: null, maxWidth: null},
    { id: 6, name: 'extracts', open: false, fullScreen: null, maxWidth: null}
  ]);

    const [modalStates, setModalStates] = useState({
      modalProduct: false,
    });

  const handleMultipleFiltersFunc = (paramsAndValues) => {
    handleMultipleFilters(paramsAndValues, filtersChanged, setFiltersChanged);
  };

  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const getSalesInfos = (currentFilters) => {
    const params = currentFilters.map((filter) => filter.urlParam).join('&');

    setSalesInfos({
      ...salesInfos,
      loading: true,
    });

    axios
      .get(
        `${environments.dashBoard}/cmvCount/sales?restaurantId=${getId}&${params}`
      )
      .then((response) => {
        setSalesInfos({
          loading: false,
          content: response?.data || ''
        });
      })
      .catch((error) => {
        console.log(error);
        setSalesInfos({
          loading: false,
          content: ''
        });
      });
  };

  const getCmvTheoretical = (currentFilters) => {
    const params = currentFilters.map((filter) => filter.urlParam).join('&');

    setCmvTheoreticalInfos({
      ...cmvTheoreticalInfos,
      loading: true,
    });

    axios
      .get(
        `${environments.dashBoard}/cmvCount/theory?restaurantId=${getId}&${params}`
      )
      .then((response) => {
        setCmvTheoreticalInfos({
          loading: false,
          content: response?.data || ''
        });
      })
      .catch((error) => {
        console.log(error);
        setCmvTheoreticalInfos({
          loading: false,
          content: ''
        });
      });
    
    setLoading(false);
  };

  const getCmvPerformed = (currentFilters) => {
    const params = currentFilters.map((filter) => filter.urlParam).join('&');

    setCmvPerformedInfos({
      ...cmvPerformedInfos,
      loading: true,
    });

    axios
      .get(
        `${environments.dashBoard}/cmvCount/realized?restaurantId=${getId}&${params}`
      )
      .then((response) => {
        setCmvPerformedInfos({
          loading: false,
          content: response?.data || ''
        });
      })
      .catch((error) => {
        console.log(error);
        setCmvPerformedInfos({
          loading: false,
          content: ''
        });
      });
    
    setLoading(false);
  };

    const handleClose = (modal) => {
      setModalStates({ ...modalStates, [modal]: false });
    };

  const getCmvChartInfos = (currentFilters) => {
    const params = currentFilters.map((filter) => filter.urlParam).join('&');

    setCmvChartInfos({
      ...cmvChartInfos,
      loading: true
    })

    const URL = `${environments.dashBoard}/cmvCount/graph?restaurantId=${getId}&${params}`

    axios.get(URL)
      .then((response) => {
        const mainObj = response?.data?.content?.sort((a, b) => (a?.date > b?.date ? 1 : -1))
        const yMinEl = Math.min(...mainObj?.map(el => el?.date)?.map(el => el))
        const yMaxEl = Math.max(...mainObj?.map(el => el?.date)?.map(el => el))

        setCmvChartInfos({
          contentFormatted: [
            {
              title: 'cmv realizado',
              data: mainObj?.map(el => parseFloat(el?.cmv?.realized || 0)),
              dataDiscount: mainObj?.map(el => parseFloat(el?.cmv?.realizedDiscount || 0)),
              dataFormatted: mainObj?.map((el, index) => ({
                index,
                item: `${parseFloat(el?.cmv?.realized || 0).toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}% (R$ ${el?.cmv?.realizedMonetary?.toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })})`
              })),
              dataFormattedDiscount: mainObj?.map((el, index) => ({
                index,
                item: `${parseFloat(el?.cmv?.realizedDiscount || 0).toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}% (R$ ${(el?.cmv?.realizedDiscountMonetary || 0)?.toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })})`
              })),
              color: '#5062F0'
            },
            {
              title: 'cmv teórico',
              data: mainObj?.map(el => parseFloat(el?.cmv?.theory || 0)),
              dataDiscount: mainObj?.map(el => parseFloat(el?.cmv?.theoryDiscount || 0)),
              dataFormatted: mainObj?.map((el, index) => ({
                index,
                item: `${parseFloat(el?.cmv?.theory || 0).toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}%  (R$ ${(el?.cmv?.theoryMonetary || 0)?.toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })})`
              })),
              dataFormattedDiscount: mainObj?.map((el, index) => ({
                index,
                item: `${parseFloat(el?.cmv?.theoryDiscount || 0).toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}%  (R$ ${(el?.cmv?.theoryDiscountMonetary || 0)?.toLocaleString('pt-br', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })})`
              })),
              color: '#F2B90D'
            },
          ],
          yMin: yMinEl,
          yMax: yMaxEl,
          customYLabelAfter: '%',
          labels: mainObj?.map(el => moment(el?.date)?.format('DD/MM')),
          dates: mainObj?.map(el => el?.date),
          loading: false
        })
      })
      .catch((error) => {
        setCmvChartInfos({
          content: [],
          contentFormatted: [],
          labels: [],
          loading: false
        })
        console.log(error);
      });
  }

  const getTotalCount = () => {
    const initialDateFormatted = moment(filterStartDate).format('YYYY-MM-DD');
    const endDateFormatted = moment(filterEndDate).format('YYYY-MM-DD');

    if (initialDateFormatted !== 'Data inválida' && endDateFormatted !== 'Data inválida') {
      const URL = `${environments.dashBoard}/cmvView/totalCountCmv?restaurantId=${getId}&startDate=${initialDateFormatted}&endDate=${endDateFormatted}`
  
      axios.get(URL)
        .then((response) => {
          setTotalProductsCount(response?.data)
        })
        .catch((error) => {
  
          console.log(error);
        });
    }
  }

  useEffect(() => {
    getTotalCount()
  }, [dateChangeStart, dateChangeEnd, getId])

  const cmvAndCountSetupButton = () => (
    <Tooltip title="Contagem necessária para compor seu CMV" aria-label="add">
      <IconButton
        className="p0"
        color="primary"
        aria-label="add"
        component="span"
        onClick={() => {
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'cmvAndCountSetupDialog' ? { ...modal, open: true } : modal
            )
          );
        }}
      >
        <img
          style={{ width: '25px' }}
          src={CmvAndCountSetupIcon}
          alt="CmvAndCountSetupIcon"
        />
      </IconButton>
    </Tooltip>
  );

  const onDateFilterEndMonthChange = (startDate, endDate, isFirstLoad = false) => {
    const currentStartDate = startDate ? moment(startDate)?.format('YYYY-MM-DD') : moment(actualDateLessSeven).add(3, 'hours').startOf('month')?.format('YYYY-MM-DD')
    const currentEndDate = endDate ? moment(endDate)?.format('YYYY-MM-DD') : moment(actualDateLessSeven).add(3, 'hours').endOf('month')?.format('YYYY-MM-DD')

    axios
      .get(
        `${environments.dashBoard}/cmvCount/dates?restaurantId=${getId}&startDate=${currentStartDate}&endDate=${currentEndDate}`
      )
      .then((response) => {
        const defaultSevenDays = [...Array(7).keys()]
        const hasPeriodicity = response?.data?.periodicity
        const enabledCurrentDates = response?.data?.dates?.length
          ? response?.data?.dates?.sort((a, b) => (a > b ? 1 : -1)) 
          : []
        const enabledNextDates = response?.data?.next?.length
          ? response?.data?.next?.sort((a, b) => (a > b ? 1 : -1)) 
          : []
        const useCurrentOrNextDates = enabledNextDates?.length > 1 
          ? isFirstLoad ? enabledNextDates : enabledCurrentDates
          : enabledCurrentDates
        const disabledDays = useCurrentOrNextDates?.length
          ? useCurrentOrNextDates 
          : hasPeriodicity && isFirstLoad
            ? defaultSevenDays?.map(el => moment()?.subtract(el + 1, 'day')?.format('YYYY-MM-DD'))
            : []

        setEnabledCurrentEndDates(useCurrentOrNextDates)
        setEndDateDisabledDays(disabledDays?.map(el => moment(el)?.format('YYYY-MM-DD')))
        setLoadedEndDateDays(true)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const onMonthStartDateChange = (startDate, endDate, isFirstLoad = false, useCurrentMonth = false) => {
    const currentStartDate = startDate ? moment(startDate)?.format('YYYY-MM-DD') : moment(actualDateLessThirty).add(3, 'hours').startOf('month')?.format('YYYY-MM-DD')
    const currentEndDate = endDate ? moment(endDate)?.format('YYYY-MM-DD') : moment(actualDateLessThirty).add(3, 'hours').endOf('month')?.format('YYYY-MM-DD')
    
    axios
      .get(
        `${environments.dashBoard}/cmvCount/dates?restaurantId=${getId}&startDate=${currentStartDate}&endDate=${currentEndDate}`
      )
      .then((response) => {
        const defaultSevenDays = [...Array(7).keys()]
        const hasPeriodicity = response?.data?.periodicity
        const enabledCurrentDates = response?.data?.dates?.length
          ? response?.data?.dates?.sort((a, b) => (a > b ? 1 : -1)) 
          : []
        const enabledNextDates = response?.data?.next?.length
          ? response?.data?.next?.sort((a, b) => (a > b ? 1 : -1)) 
          : []
        const useCurrentOrNextDates = enabledNextDates?.length > 1 && !useCurrentMonth
          ? enabledNextDates
          : enabledCurrentDates
        const disabledDays = useCurrentOrNextDates?.length
          ? useCurrentOrNextDates
          : hasPeriodicity && isFirstLoad
            ? defaultSevenDays?.map(el => moment()?.subtract(el + 1, 'day')?.format('YYYY-MM-DD'))
            : []

        if (isFirstLoad) {
          const allDatesFlattened = [enabledCurrentDates, enabledNextDates].flat()
          const currentFirstStartDate = allDatesFlattened?.length
            ? moment(allDatesFlattened?.at(-2)).add(3, 'hours') 
            : moment(actualDateLessThirty).add(3, 'hours') 
          const currentFirstEndDate = allDatesFlattened?.length 
            ? moment(allDatesFlattened[allDatesFlattened?.length - 1]).add(3, 'hours') 
            : moment(actualDateLessOne).add(3, 'hours');

          setFilterStartDate(currentFirstStartDate)
          setDateChangeStart(currentFirstStartDate)
          setFilterOldStartDate(currentFirstStartDate)
          setFilterEndDate(currentFirstEndDate)
          setDateChangeEnd(currentFirstEndDate)
          setFilterOldEndDate(currentFirstEndDate)

          setFiltersChanged([
            {
              param: 'startDate',
              value: moment(currentFirstStartDate)?.format('YYYY-MM-DD'),
              urlParam: `startDate=${moment(currentFirstStartDate)?.format('YYYY-MM-DD')}`,
            },
            {
              param: 'endDate',
              value: moment(currentFirstEndDate)?.format("YYYY-MM-DD"),
              urlParam: `endDate=${moment(currentFirstEndDate)?.format("YYYY-MM-DD")}`,
            }
          ])
        }

        onDateFilterEndMonthChange("", "", isFirstLoad)

        setEnabledCurrentStartDates(enabledCurrentDates)
        setEnabledNextStartDates(enabledNextDates)
        setStartDateDisabledDays(disabledDays?.map(el => moment(el)?.format('YYYY-MM-DD')))
        setLoadedStartDateDays(true)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleStartDateChange = (date, shouldDisableStartDate) => {
    const selectedDay = moment(date)?.format('YYYY-MM-DD')
    const selectedDayIsLastOfMonth = shouldDisableStartDate?.length ? shouldDisableStartDate[shouldDisableStartDate.length - 1] === selectedDay : false
    const selectedDateCurrentIndex = enabledCurrentStartDates.indexOf(date) === -1 ? enabledNextStartDates.indexOf(date) : enabledCurrentStartDates.indexOf(date)
    const selectedDateCurrentDateEnabled = selectedDateCurrentIndex !== -1 && selectedDateCurrentIndex < (enabledCurrentStartDates?.length - 1 || selectedDateCurrentIndex < enabledNextStartDates?.length - 1)
      ? enabledCurrentStartDates.indexOf(date) === -1 ? enabledNextStartDates[selectedDateCurrentIndex + 1] : enabledCurrentStartDates[selectedDateCurrentIndex + 1]
      : null; 

    setFilterStartDate(moment(date))
    setDateChangeStart(moment(date))

    if (selectedDayIsLastOfMonth && enabledNextStartDates?.length) {
      handleMultipleFiltersFunc([
        ['startDate', date],
        ['endDate', enabledNextStartDates[0]]
      ]);

      setFilterEndDate(moment(enabledNextStartDates[0]))
      setDateChangeEnd(moment(enabledNextStartDates[0]))
    } else {

      handleMultipleFiltersFunc([
        ['startDate', date],
        ['endDate', selectedDateCurrentDateEnabled || date]
      ]);

      setFilterEndDate(moment(selectedDateCurrentDateEnabled || date))
      setDateChangeEnd(moment(selectedDateCurrentDateEnabled || date))
    }
  }

  const handleFinalDateChange = (date) => {
    setFilterEndDate(moment(date))
    setDateChangeEnd(moment(date))

    if (new Date(date) < new Date(filterStartDate)) {
      const newDate = moment(date).format('YYYY-MM-DD');
      handleMultipleFiltersFunc([
        ['startDate', newDate],
        ['endDate', newDate]
      ]);

      setFilterStartDate(moment(date));
      setDateChangeStart(moment(date))
      return;
    }

    const newDate = moment(date).format('YYYY-MM-DD');
    handleMultipleFiltersFunc([['endDate', newDate]]);
  }

  const customDateFilter = () => (
    <section className="fakeHeaderAndFilterBox">
      <div className="fakeHeaderBox">
        <h1>
          CMV
        </h1>

        <div className="dFlex alignCenter">
          {cmvAndCountSetupButton()}

          <img
            style={{ width: 25 }}
            src={openFilter ? FilterOpened : FilterClosed} 
            onClick={() => {
              setOpenFilter(!openFilter)
            }} 
            className="cursorPointer ml10"
            alt="FilterIcon"
          />
        </div>
      </div>

      <div className={`${!openFilter && 'closedFilter'} fakeFilterBox`}>
        <div className="dFlex pt16 pr16 pb16 pl16" style={{width: "15%"}}>
          <div className="dateFilterStartBox w50">
            <span className="fakeLabel">
              Início
            </span>

            <DatePicker
              ref={startDatePickerRef}
              value={new Date(filterStartDate)}
              onChange={(date) => {
                const day = date?.day
                const month = date?.month
                const year = date?.year
                const formattedDate = moment(`${year}-${month}-${day}`)?.format('YYYY-MM-DD');
                isStartDateSelectedRef.current = true;
                
                if (enabledCurrentStartDates?.includes(formattedDate) || enabledNextStartDates?.includes(formattedDate)) {
                  handleStartDateChange(formattedDate, startDateDisabledDays)
                }
              }}
              calendar="gregorian"
              format="DD/MM"
              weekDays={["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]}
              months={[
                "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
              ]}
              placeholder="Selecione uma data"
              onMonthChange={(value) => {
                const dateFormatted = value.toDate()
                const startOfMonth = moment(dateFormatted).startOf('month').format('YYYY-MM-DD');
                const endOfMonth   = moment(dateFormatted).endOf('month').format('YYYY-MM-DD');

                setFilterStartDate(dateFormatted)
                
                onMonthStartDateChange(startOfMonth, endOfMonth, false, true)
              }}
              onOpen={() => {
                startDatePickerRef.current = filterStartDate;
                isStartDateSelectedRef.current = false;
                setFilterOldStartDate(moment(filterStartDate))
              }}
              onClose={() => {
                if (!isStartDateSelectedRef?.current) {
                  setFilterStartDate(filterOldStartDate)
                  setDateChangeStart(filterOldStartDate)
                }
              }}
              mapDays={(date) => {
                const day = date?.date?.day
                const month = date?.date?.month
                const year = date?.date?.year
                const formattedDate = moment(`${year}-${month}-${day}`)?.format('YYYY-MM-DD');

                if (!startDateDisabledDays.includes(formattedDate)) {
                  return { disabled: true, style: { color: "rgba(0, 0, 0, 0.38)" } };
                }
              }}
              style={{ width: "100%" }}
            />

            <img
              onClick={openStartCalendar}
              src={CalendarFilterIcon}
              alt="CalendarFilterIcon"
            />
          </div>

          <div className="dateFilterEndBox">
            <span className="fakeLabel">
              Fim
            </span>

            <DatePicker
              ref={endDatePickerRef}
              value={new Date(filterEndDate)}
              onChange={(date) => {
                const day = date?.day
                const month = date?.month
                const year = date?.year
                const formattedDate = moment(`${year}-${month}-${day}`)?.format('YYYY-MM-DD');
                isEndDateSelectedRef.current = true;

                if (enabledCurrentEndDates?.includes(formattedDate)) {
                  handleFinalDateChange(formattedDate)
                }
              }}
              calendar="gregorian"
              format="DD/MM"
              weekDays={["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]}
              months={[
                "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
              ]}
              placeholder="Selecione uma data"
              onMonthChange={(value) => {
                const dateFormatted = value.toDate()
                const startOfMonth = moment(dateFormatted).startOf('month').format('YYYY-MM-DD');
                const endOfMonth   = moment(dateFormatted).endOf('month').format('YYYY-MM-DD');

                setFilterEndDate(dateFormatted)
                onDateFilterEndMonthChange(startOfMonth, endOfMonth)
              }}
              onOpen={() => {
                endDatePickerRef.current = filterEndDate;
                isEndDateSelectedRef.current = false;
                setFilterOldEndDate(moment(filterEndDate))
              }}
              onClose={() => {
                if (!isEndDateSelectedRef?.current) {
                  setFilterEndDate(filterOldEndDate)
                  setDateChangeEnd(filterOldEndDate)
                }
              }}
              mapDays={(date) => {
                const day = date?.date?.day
                const month = date?.date?.month
                const year = date?.date?.year
                const formattedDate = moment(`${year}-${month}-${day}`)?.format('YYYY-MM-DD');

                if (!endDateDisabledDays.includes(formattedDate)) {
                  return { disabled: true, style: { color: "rgba(0, 0, 0, 0.38)" } };
                }
              }}
              style={{ width: "100%" }}
            />

            <img
              onClick={openEndCalendar}
              src={CalendarFilterIcon}
              alt="CalendarFilterIcon"
            />
          </div>
        </div>

        <div className='dFlex justifyBetween totalizer' style={{width: '30%'}}>
          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            PopperProps={{ disablePortal: true }}
            interactive
            title={
              <div
                className="dFlex flexColumn"
                style={{ padding: "4px 2px" }}
              >
                <div className="dFlex flexColumn bold">
                  <span className={`${totalProductsCount?.notConfigProducts?.length && 'mb8'}`}>
                    {totalProductsCount?.notConfigProducts?.length
                      ? 'Produtos com configuração pendente:'
                      : 'Nenhum produto com configuração pendente'
                    }
                  </span> 
                  
                  <div className="productsBox dFlex flexColumn" style={{ maxHeight: '205px', overflow: 'auto' }}>
                    {totalProductsCount?.notConfigProducts?.map(el => (
                      <span>
                        {el?.description}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            }
          >
            <span>
              <p className='colorDesc'>produtos configurados</p>
              <p 
                style={{color: `${totalProductsCount?.nConfigProducts === totalProductsCount?.nTotalProducts ? '#006608' : '#AA8208'}`}}
              >
                {totalProductsCount?.nConfigProducts || 0} / {totalProductsCount?.nTotalProducts || 0}
              </p>
            </span>
          </Tooltip>
            
          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            PopperProps={{ disablePortal: true }}
            interactive
            title={
              <div
                className="dFlex flexColumn"
                style={{ padding: "4px 2px" }}
              >
                <div className="dFlex flexColumn bold" style={{ maxHeight: 205, overflow: 'auto' }}>
                  <span className={`${totalProductsCount?.counts[0]?.notCountedProducts?.length && 'mb8'}`}>
                    {totalProductsCount?.counts[0]?.notCountedProducts?.length 
                      ? 'Produtos com contagem pendente:'
                      : 'Nenhum produto com contagem pendente'
                    }
                  </span> 
                  
                  {totalProductsCount?.counts[0]?.notCountedProducts?.map(el => (
                    <span>
                      {el?.description}
                    </span>
                  ))}
                </div>
              </div>
            }
          >
            <div>
              <p className='colorDesc'>contagem {moment(dateChangeStart).format('DD/MM')}</p>
              <p 
                style={{color: `${parseFloat(totalProductsCount?.counts[0]?.percent) === 100 ? '#006608' : '#AA8208'}`}}
              >
                {totalProductsCount?.counts[0]?.percent || 0}%
              </p>
            </div>
          </Tooltip>

          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            PopperProps={{ disablePortal: true }}
            interactive
            title={
              <div
                className="dFlex flexColumn"
                style={{ padding: "4px 2px" }}
              >
                <div className="dFlex flexColumn bold" style={{ maxHeight: 205, overflow: 'auto' }}>
                  <span className={`${totalProductsCount?.counts[1]?.notCountedProducts?.length && 'mb8'}`}>
                    {totalProductsCount?.counts[1]?.notCountedProducts?.length 
                      ? 'Produtos com contagem pendente:'
                      : 'Nenhum produto com contagem pendente'
                    }
                  </span> 
                  
                  {totalProductsCount?.counts[1]?.notCountedProducts?.map(el => (
                    <span>
                      {el?.description}
                    </span>
                  ))}
                </div>
              </div>
            }
          >
            <div>
              <p className='colorDesc'>contagem {moment(dateChangeEnd).format('DD/MM')}</p>
              <p 
                style={{color: `${parseFloat(totalProductsCount?.counts[1]?.percent) === 100 ? '#006608' : '#AA8208'}`}}
              >
                {totalProductsCount?.counts[1]?.percent || 0}%
              </p>
            </div>
          </Tooltip>
        </div>
      </div>
    </section>
  )

  useEffect(() => {
    if (loadedStartDateDays && loadedEndDateDays) {
      getSalesInfos(filtersChanged);
      getCmvTheoretical(filtersChanged);
      getCmvPerformed(filtersChanged)
    }
  }, [filtersChanged, loadedStartDateDays, loadedEndDateDays]);

  useEffect(() => {
    getCmvChartInfos(filtersChanged)
  }, [paramsID]);

  useEffect(() => {
    setId(paramsID);

    onMonthStartDateChange("", "", true)
  }, [paramsID]);

  return (
    <Layout>
      <TitleHead title="CMV Dashboard" />

      <GlobalStyle />

      <Container className="cmvDashboardPage">
        {customDateFilter()}

        <section className="cmvDashboardContainer">
          <SalesInfos
            salesInfos={salesInfos}
            salesInfoType={salesInfoType}
            setSalesInfoType={setSalesInfoType}
            paramsID={paramsID}
            startDateChanged={filterStartDate}
            endDateChanged={filterEndDate}
          />

          <div className="dFlex">
            <CmvTheoreticalInfos 
              cmvTheoreticalInfos={cmvTheoreticalInfos}
              salesInfoType={salesInfoType}
            />

            <PerformedCmvInfos
              cmvPerformedInfos={cmvPerformedInfos}
              salesInfoType={salesInfoType}
              setModalSettings={setModalSettings}
              modalSettings={modalSettings}
              filtersChanged={filtersChanged}
              companyActive={companyActive}
            />
          </div>

          <div className="cmvChartInfosCard">
            <SimpleLineGraphic
              paramsID={paramsID}
              mainContent={cmvChartInfos}
              salesInfoType={salesInfoType}
              // actualDateLessOne={actualDateLessOne}
              // actualDateLessFourteen={actualDateLessFourteen}
            />
          </div>
        </section>
      </Container>

      <CommonAlert
        open={!!message.description}
        onClose={() => {
          setMessage({ description: '', status: '' })
        }}
        severity={message.status}
        indexMessage={message.description}
        messagePersonal={message.description}
      />

      {modalSettings.find((modal) => modal.name === 'cmvAndCountSetupDialog').open && (
        <Suspense fallback={<span />}>
          <CmvAndCountSetupDialog
            open={modalSettings.find((modal) => modal.name === 'cmvAndCountSetupDialog').open}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            updateStorageLocations={updateStorageLocations}
            setMessage={setMessage}
            userInfo={userInfo}
            defaultDate={filtersChanged?.find(el => el?.param === 'endDate')?.value}
          />
        </Suspense>
      )}

      {modalSettings.find((modal) => modal.name === 'differenceInCount')
        .open && (
        <Suspense fallback={<span />}>
          <DifferenceInCount
            open={
              modalSettings.find((modal) => modal.name === 'differenceInCount')
                .open
            }
            handleClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'differenceInCount'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            setInfoDiscard={setInfoDiscard}
            infoDiscard={infoDiscard}
            setFilterStartDifferenceDate={setFilterStartDifferenceDate}
            setFilterEndDiferrenceDate={setFilterEndDiferrenceDate}
          />
        </Suspense>
      )}

      {modalSettings.find((modal) => modal.name === 'performedCmvInfos')
        .open && (
        <Suspense fallback={<span />}>
          <PerformedCmvDialogInfos
            open={
              modalSettings.find((modal) => modal.name === 'performedCmvInfos')
                .open
            }
            handleClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'performedCmvInfos'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            startDate={filtersChanged?.find(el => el?.param === 'startDate')?.value}
            endDate={filtersChanged?.find(el => el?.param === 'endDate')?.value}
            initialStockTotal={cmvPerformedInfos?.content?.initialStock || 0}
            shoppingTotal={cmvPerformedInfos?.content?.orders || 0}
            transfersTotal={cmvPerformedInfos?.content?.transfers || 0}
            finalStockTotal={cmvPerformedInfos?.content?.finalStock || 0}
          />
        </Suspense>
      )}

      {modalSettings.find((modal) => modal.name === 'storageLocationDialog').open && (
        <StorageLocationForm
          isModal
          openModal={modalSettings.find((modal) => modal.name === 'storageLocationDialog').open}
          redirectPath={null}
          setUpdateList={setUpdateStorageLocations}
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'storageLocationDialog' ? { ...modal, open: false } : modal
              )
            );
          }}
          createMode
        />
      )}

      {modalSettings.find((modal) => modal.name === 'discardPercentageAndValue')?.open && (
        <Suspense fallback={<span>Carregando...</span>}>
          <DiscardPercentageAndValue
            open={modalSettings.find((modal) => modal.name === 'discardPercentageAndValue')?.open}
            handleClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'discardPercentageAndValue'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            setProductModal={setProductModal}
            initialDate={filterStartDifferenceDate || moment(filterStartDate).add(1, 'day')}
            countDate={filterEndDifferenceDate || filterEndDate}
            currentRestaurant={userInfo.companiesActive.name}
            setModalSettings={setModalSettings}
            modalSettings={modalSettings}
            infoDiscard={infoDiscard}
            setInfoDiscard={setInfoDiscard}
            setModalStates={setModalStates}
            cmvPage
          />
        </Suspense>
      )}

      {modalStates.modalProduct && (
        <Suspense fallback={<span />}>
          <TheoryStockDialog
            getId={getId}
            openModal={modalStates}
            checkConsume={checkConsume}
            setCheckConsume={setCheckConsume}
            handleClose={handleClose}
            productAge={null}
            productModal={productModal}
            setProductModal={setProductModal}
            customClassName="countPageExtractDialog"
            originPage="countPage"
            defaultStartDate={
              new Date(
                moment(
                  modalSettings.find((modal) => modal.name === 'extracts').startDate
                )
              )
            }
            countDate={filterEndDate || 
              modalSettings.find((modal) => modal.name === 'extracts').endDate
            }
            defaultExtractType={
              modalSettings.find((modal) => modal.name === 'extracts').extractType
            }
          />
        </Suspense>
      )}
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

export default connect(mapStateToProps)(CmvDashboard);